import { Fragment } from "react";

import { Card, CardBody } from "reactstrap";

const ContactUsPage = () => {
  return (
    <Fragment>
      <Card className="mb-0">
        <CardBody></CardBody>
      </Card>
    </Fragment>
  );
};

export default ContactUsPage;
